import { Component, Input } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { FlatpickrModule } from 'angularx-flatpickr';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, FlatpickrModule, IconModule, MaterialModule],
  selector: 'app-dashboard-sub-module',
  templateUrl: './dashboard-sub-module.component.html',
  styleUrl: './dashboard-sub-module.component.scss'
})
export class DashboardSubModuleComponent {
  @Input() moduleName: string = '';
  @Input() className: string = '';
  @Input() classBar: string = '';
  @Input() path: string = '';
  @Input() moduleCount: string = '';
  @Input() percentageValue: string = '';
  @Input() tagLabel: string = '';
  @Input() badgeSuffix: string = '%';

  get isNegative(): boolean {
    return this.percentageValue.startsWith('-');
  }

  get trendBadgeClass(): string {
    return this.isNegative
      ? 'bg-danger/10 text-danger'
      : 'bg-success/10 text-success';
  }

  get trendDisplay(): string {
    const arrow = this.isNegative ? '↓' : '↑';
    const num = this.percentageValue.replace('+', '').replace('-', '');
    return `${arrow} ${num}${this.badgeSuffix}`;
  }
}
